export default "__VITE_ASSET__D3GVezC2__"